import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalForm, ModalFormContainer } from "../../../../theme";
import Select from "react-select-plus";
import { isAccess } from "../../../../common/utils";
import { debounce } from "../../../../../helpers/common";
import Creatable from "react-select-plus/lib/Creatable";

export class LLMProviderAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `LLM Provider`;
    this.moduleUrl = `config/llm/provider`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
    // this.state = {
    //   options: [],
    // };
  }
  setData(editData = {}) {
    editData = editData || {};
    this.state = {
      isLoading: false,
      key: editData.key || "",
      label: editData.label || "",
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      key: "",
      label: "",
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
      this.setState({ isLoading: false });
    }
  }

  saveData(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    let _this = this;
    let tData = {
      key: this.state.key,
      label: this.state.label,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
          }
          this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: this.props.editData._id },
        "PATCH"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} created successfully.`);
          this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
          this.setState({ isLoading: false });
        },
        "public"
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Display Name", {
                defaultValue: "",
                placeholder: "Display Name",
                autoFocus: true,
                required: true,
                id: "label",
                value: this.state.label,
                onChange: (e) => {
                  if (e.target.value === " " || e.target.value.length > 20) {
                    return false;
                  }
                  this.setState({
                    label: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Key", {
                defaultValue: "",
                placeholder: "Key",
                autoFocus: false,
                required: true,
                id: "key",
                disabled:
                  this.props.editData && this.props.editData._id ? true : false,
                value: this.state.key,
                onChange: (e) => {
                  if (e.target.value === " " || e.target.value.length > 20) {
                    return false;
                  }
                  this.setState({
                    key: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            // btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            isLoading={this.state.isLoading}
            disabled={this.state.isLoading}
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

LLMProviderAddEdit.propTypes = {
  group: PropTypes.array,
};

LLMProviderAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default LLMProviderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/LLMProvider/components/LLMProviderAddEdit.js